var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.SHOW_LOGO)?_c('div',[_c('v-touch',{staticClass:"test-coupon",attrs:{"tag":"div"},on:{"tap":function($event){return _vm.goActivty()}}},[_c('img',{attrs:{"src":_vm.logoSrc}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/couponLogo.vue?vue&type=template&id=678e1042&scoped=true&
// module id = null
// module chunks = 